module.exports = __webpack_public_path__ + "81015a60e336ce443894ea331b370e4e.pdf";